<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<h1 class="h3 mb-0 text-gray-800">
					Unidades de Medida
				</h1>
				<div class="noprint">
					<button 
						class="btn btn-primary"
						@click="create()">
						Novo
					</button>
					<button 
				    	@click="$router.go(-1)" 
				    	class="btn btn-secondary">
			        	Voltar
			        </button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <categoria-table
		            	link="/api/adm/unidades-medida/data"
		            	:key="unidadeTableKey"
		            	@update="update"
		            	@destroy="destroy">
		            </categoria-table>
		        </div>
		    </div>
		</div>
		<!-- Create -->
		<categoria-create
			title="Nova Unidade de Medida"
			link="/api/adm/unidades-medida/store"
			@reload="reload">
		</categoria-create>
		<!-- Update -->
		<categoria-update
			title="Editar Unidade de Medida"
			link="api/adm/unidades-medida"
			:dado_id="dado_id"
			@reload="reload">
		</categoria-update>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_medida" 
        	:dado_id="dado_id" 
        	title="Deseja realmente excluir esta medida?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/unidades-medida/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0,
				unidadeTableKey: 0
			}
		},
		methods: {
			create(){
				$('#create_categoria').modal('show');
			},
			update(id){
				this.dado_id = id;
				$('#update_categoria').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_medida').modal('show');
			},
			reload(){
				this.unidadeTableKey += 1;
			}
		}
	}
</script>